'use client';

import React from 'react';
import classNames from 'classnames';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { LeftNavigationPanel, LeftNavigationPanelProps } from '@/components/composite/LeftNavigationPanel';
import { FullscreenExitButton } from './FullscreenExitButton';
import { useFullscreenMode } from './hooks/useFullscreenMode';
import styles from './NavigationLayout.module.scss';

interface NavigationLayoutProps {
  contentClassName?: string;
  parentRoute?: LeftNavigationPanelProps['parentRoute'];
  fullSizeContent?: boolean;
}

export const NavigationLayout: React.FC<React.PropsWithChildren<NavigationLayoutProps>> = ({
  parentRoute,
  contentClassName,
  fullSizeContent,
  children,
}) => {
  const { isFullscreen } = useFullscreenMode();

  return (
    <div className={classNames(styles.container, 'relative flex flex-row')}>
      {!isFullscreen && <LeftNavigationPanel position="relative" parentRoute={parentRoute} showFullscreenToggle />}
      <div
        className={classNames(
          'flex flex-1 flex-col overflow-y-auto',
          { [styles.fullSizeContent]: fullSizeContent },
          contentClassName,
        )}
      >
        <ErrorBoundary>{children}</ErrorBoundary>
      </div>
      {isFullscreen && <FullscreenExitButton />}
    </div>
  );
};
